import GenericRequest, { METHOD_GET } from '../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../shared/webservices/endpoint';

export default class TypeDocumentsRequest extends GenericRequest {

    constructor() {
        super(METHOD_GET, ApiEndpoints.FYLE_TYPE);
    }
}



// WEBPACK FOOTER //
// ./src/app/documents/ws/FileTypeRequest.js